import { render, staticRenderFns } from "./SelectStrategyImportFromPsd.vue?vue&type=template&id=09867a57"
import script from "./SelectStrategyImportFromPsd.vue?vue&type=script&lang=js"
export * from "./SelectStrategyImportFromPsd.vue?vue&type=script&lang=js"
import style0 from "./SelectStrategyImportFromPsd.vue?vue&type=style&index=0&id=09867a57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports